import { render, staticRenderFns } from "./WidgetsTable.vue?vue&type=template&id=22264806&"
import script from "./WidgetsTable.vue?vue&type=script&lang=js&"
export * from "./WidgetsTable.vue?vue&type=script&lang=js&"
import style0 from "./WidgetsTable.vue?vue&type=style&index=0&id=22264806&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports